import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export default function Cta({ children }: Props) {
  return <section className='cta'>{children}</section>
}

Cta.scheme = {
  render: 'Cta'
}
